import React from 'react';

interface CustomRowProps {
    children: React.ReactNode;
}


export const CustomRow: React.FC<CustomRowProps> = ({ children }) => {
    return (
        <div className="form-row">
            {children}
        </div>
    );
};
